// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Oswald', 'Oswald Fallback'","fontStyle":"normal"},"className":"__className_ca7aa5","variable":"__variable_ca7aa5"};